<!--
A group of checkboxes, allowing multiple options within the group to be selected.
-->

<template>
	<div class="filter-checkbox-group">
		<label v-for="item in checkboxes" :key="item.id">
			<input type="checkbox" :id="filter + item.id" :name="filter + item.id" :value="item.id" v-model="selected">{{ item.label }}
		</label>
	</div>
</template>

<script>
export default {
	computed: {
		selected: {
			get: function () {
				const value = this.$store.getters.selectedFilterValues[this.filter];

				if (typeof value == 'undefined')
					return [];

				return value;
			},
			set: function (value) {
				this.$store.dispatch('setSelectedFilterValues', { name: this.filter, value: value });
			},
		},
	},
	props: {
		filter: {
			type: String,
			required: true,
		},
		checkboxes: {
			type: Array,
			required: true,
		},
	},
}
</script>

<style lang="scss" scoped>
label {
	display: block;
	font-weight: normal;
	margin: 2px 0px;
}

.filter-checkbox-group input {
	margin: 0px;
	margin-right: 4px;
	vertical-align: middle;
}
</style>
